module.exports = __webpack_public_path__ + "static/media/scan.0d1ba9c2.svg";